import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { mensajeAmigable } from '../utils/errores';
import { obtenerCitas, cambiarEstadoCita, eliminarCita } from '../services/citasService';
import { obtenerClientes } from '../services/clientesService';
import { linkWhatsAppA } from '../utils/compartir';
import { ESTADOS_CITA, estadoCitaInfo, etiquetaDia, horaBonita, agruparPorDia, hoyISO } from '../utils/citas';
import CitaForm from './CitaForm';

const P = 'var(--color-primario,#DB2777)';

export default function AgendaView({ onVolver }) {
  const { negocio } = useAuth();
  const { mostrarToast } = useToast();
  const { puede } = useAuth();
  const esVendedora = !puede('borrar'); // sin permiso "Borrar registros" (también lo bloquea la BD)
  const [citas, setCitas] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [error, setError] = useState(null);
  const [soloProximas, setSoloProximas] = useState(true);
  const [form, setForm] = useState(null); // null | { cita? }

  useEffect(() => { obtenerClientes().then(setClientes).catch(() => {}); }, []);

  // Abre WhatsApp con un recordatorio ya escrito para la clienta.
  const recordarWhatsApp = (c) => {
    const cli = clientes.find((x) => x.id === c.cliente_id);
    const tel = cli?.telefono || '';
    const dia = new Date(c.fecha + 'T00:00:00').toLocaleDateString('es', { weekday: 'long', day: 'numeric', month: 'long' });
    const hora = c.hora ? ` a las ${horaBonita(c.hora)}` : '';
    const serv = c.servicio_nombre ? ` para *${c.servicio_nombre}*` : '';
    const nombre = (c.cliente_nombre || '').trim().split(' ')[0] || '';
    const saludo = nombre ? `Hola ${nombre}! 👋` : '¡Hola! 👋';
    const reunion = c.enlace_reunion ? `\n\n🎥 Enlace de la reunión: ${c.enlace_reunion}` : '';
    const firma = negocio?.nombre ? `\n\n${negocio.nombre}` : '';
    const msg = `${saludo} Te recuerdo nuestra cita${serv} el ${dia}${hora}. ¡Nos vemos! 💜${reunion}${firma}`;
    const url = tel ? linkWhatsAppA(tel, msg) : `https://api.whatsapp.com/send?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const cargar = async () => {
    setError(null);
    try { setCitas(await obtenerCitas(soloProximas ? { desde: hoyISO() } : {})); }
    catch (e) { setError(mensajeAmigable(e)); }
  };
  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [soloProximas]);

  const cambiar = async (c, estado) => {
    try {
      await cambiarEstadoCita(c.id, estado);
      setCitas((prev) => prev.map((x) => x.id === c.id ? { ...x, estado } : x));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const borrar = async (c) => {
    if (!window.confirm('¿Eliminar esta cita?')) return;
    try {
      await eliminarCita(c.id);
      mostrarToast('Cita eliminada 🗑️', 'exito');
      setCitas((prev) => prev.filter((x) => x.id !== c.id));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const grupos = agruparPorDia(citas || []);

  return (
    <div className="k-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 className="k-page-title">📅 Agenda</h2>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => setForm({})} style={{ padding: '10px 18px', background: P, color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Nueva cita</button>
          <button onClick={onVolver} className="k-btn-soft">← Volver</button>
        </div>
      </div>

      {citas && citas.length >= 0 && (
        <div style={{ display: 'flex', gap: '6px', marginBottom: '16px' }}>
          <button onClick={() => setSoloProximas(true)} style={chip(soloProximas)}>Próximas</button>
          <button onClick={() => setSoloProximas(false)} style={chip(!soloProximas)}>Todas</button>
        </div>
      )}

      {!citas && !error && <div style={{ textAlign: 'center', padding: '32px', color: '#6B7280' }}>⏳ Cargando…</div>}
      {error && <p style={{ textAlign: 'center', padding: '24px', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}

      {citas && citas.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 16px', color: '#6B7280' }}>
          <div style={{ fontSize: '46px' }}>📅</div>
          <p style={{ fontWeight: 700, color: '#111827', margin: '8px 0 4px' }}>{soloProximas ? 'No tienes citas próximas' : 'Aún no tienes citas'}</p>
          <p style={{ fontSize: '14px', margin: '0 0 16px' }}>Agenda una cita con tu cliente para no olvidarla.</p>
          <button onClick={() => setForm({})} style={{ padding: '12px 22px', background: P, color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Agendar mi primera cita</button>
        </div>
      )}

      {grupos.map((g) => (
        <div key={g.fecha} style={{ marginBottom: '18px' }}>
          <div style={{ fontSize: '13px', fontWeight: 800, color: P, textTransform: 'capitalize', margin: '0 0 8px' }}>{etiquetaDia(g.fecha)}</div>
          <div style={{ display: 'grid', gap: '10px' }}>
            {g.citas.map((c) => {
              const est = estadoCitaInfo(c.estado);
              return (
                <div key={c.id} className="k-card" style={{ padding: '14px', display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ minWidth: 0, display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div style={{ textAlign: 'center', minWidth: '64px' }}>
                      <div style={{ fontSize: '15px', fontWeight: 800, color: '#111827' }}>{c.hora ? horaBonita(c.hora) : '—'}</div>
                      {c.duracion_min ? <div style={{ fontSize: '11px', color: '#9CA3AF' }}>{c.duracion_min} min</div> : null}
                    </div>
                    <div style={{ minWidth: 0, borderLeft: '2px solid #F3F4F6', paddingLeft: '12px' }}>
                      <div style={{ fontSize: '14.5px', fontWeight: 700, color: '#111827' }}>{c.cliente_nombre || 'Sin cliente'}</div>
                      {c.servicio_nombre && <div style={{ fontSize: '12.5px', color: '#6B7280' }}>{c.servicio_nombre}</div>}
                      {c.enlace_reunion && <a href={c.enlace_reunion} target="_blank" rel="noreferrer" style={{ fontSize: '12.5px', color: '#2563EB', fontWeight: 700, textDecoration: 'none' }}>🎥 Unirse a la reunión</a>}
                      {c.notas && <div style={{ fontSize: '12px', color: '#9CA3AF' }}>📝 {c.notas}</div>}
                    </div>
                  </div>
                  <span style={{ fontSize: '11.5px', fontWeight: 700, color: est.color, background: est.bg, padding: '3px 10px', borderRadius: '999px' }}>{est.emoji} {est.nombre}</span>

                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', width: '100%', justifyContent: 'flex-end', borderTop: '1px solid #F3F4F6', paddingTop: '8px' }}>
                    <select value={c.estado} onChange={(e) => cambiar(c, e.target.value)}
                      style={{ padding: '5px 8px', borderRadius: '6px', border: '1px solid #D1D5DB', fontSize: '12px', background: '#fff' }}>
                      {ESTADOS_CITA.map((e) => <option key={e.clave} value={e.clave}>{e.nombre}</option>)}
                    </select>
                    <button onClick={() => recordarWhatsApp(c)} style={{ padding: '5px 12px', background: '#DCFCE7', color: '#166534', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>📲 Recordar</button>
                    <button onClick={() => setForm({ cita: c })} style={{ padding: '5px 12px', background: '#EEF2FF', color: '#4338CA', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>✏️ Editar</button>
                    {!esVendedora && <button onClick={() => borrar(c)} style={{ padding: '5px 10px', background: 'none', border: '1px solid #FCA5A5', borderRadius: '6px', fontSize: '12px', color: '#DC2626', cursor: 'pointer' }}>🗑️</button>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {form && (
        <CitaForm cita={form.cita || null} onCerrar={() => setForm(null)} onGuardado={cargar} />
      )}
    </div>
  );
}

function chip(activo) {
  return {
    padding: '6px 14px', borderRadius: '999px', fontSize: '13px', fontWeight: 600, cursor: 'pointer',
    border: activo ? `1px solid ${P}` : '1px solid #E5E7EB',
    background: activo ? 'color-mix(in srgb, var(--color-primario,#DB2777) 10%, white)' : '#fff',
    color: activo ? P : '#6B7280',
  };
}
